import React, { useState } from "react";
import { IonButton } from "@ionic/react";
import { useGameState, requestVeto } from "context/GameContext";
import { RoundState, VetoState } from "context/interfaces/GameContextInterface";
// Comps
import LegislativeSessionItem from "./components/LegislativeSessionItem/LegislativeSessionItem";
// Css
import classes from "./LegislativeSession.module.scss";

const LegislativeSession: React.FC = () => {
  const [reveal, setReveal] = useState(false);

  const {
    dashboardRules,
    roundState,
    fascistRulesApproval,
    vetoState,
    code,
  } = useGameState();

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>Legislative Session</h2>
      <div className={classes.wrapper}>
        {dashboardRules.map((item, index) => (
          <LegislativeSessionItem
            index={index}
            item={item}
            reveal={reveal}
            key={index}
          />
        ))}
      </div>
      <p className={classes.description}>
        {roundState === RoundState.PresidentRule
          ? 'If you are the enacting president, click on the reveal button to see these three polices and discard one by tapping on the "X" button. (Do not let other players see the policies.)'
          : 'now president should pass the phone to his/her chancellor. If you are the chancellor, click on the reveal button to see these two policies and enact one by tapping on the "check mark" button. (Do not let other players see the policies.)'}
      </p>
      {!reveal && (
        <IonButton size="small" onClick={() => setReveal(true)}>
          reveal
        </IonButton>
      )}
      {reveal &&
        fascistRulesApproval === 5 &&
        roundState === RoundState.ChancellorRule &&
        vetoState === VetoState.None && (
          <IonButton size="small" onClick={() => requestVeto(code)}>
            veto
          </IonButton>
        )}
    </div>
  );
};

export default LegislativeSession;
